import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchOrders({ payload }) {
  try {
    const res = yield call(API.fetchOrderDetails, payload);
    const { data } = res;
    yield put(actions.fetchOrderDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrderDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(API.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleDownloadReport({ payload }) {
  try {
    //const res = yield call(API.getDownloadUrl, payload);
    const { fileName } = payload.data;
    const res = yield call(API.getFileUrl, {
      blobName: fileName,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const { data } = res;
    const link = document.createElement("a");
    link.href = data.data.document;
    link.setAttribute("download", payload.fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
    yield put(actions.downloadFileSuccess({ id: payload.id }));
  } catch (err) {
    yield put(actions.downloadFileFailure({ id: payload.id, err }));
  }
}

export function* handleUpdateOrderStatus({ payload }) {
  try {
    console.log(payload);
    if (payload.data.labSampleReceivedDetails) {
      yield call(
        API.saveLabSampleResponseDetails,
        payload.data.labSampleReceivedDetails
      );
    }
    delete payload.data.labSampleReceivedDetails;
    const res = yield call(API.updateOrder, payload);
    const { data } = res;
    if (res.data.status === "error") {
      yield put(actions.updateOrderStatusFailure(data));
    } else {
      yield put(actions.updateOrderStatusSuccess(data));
      if (payload.onSuccess) {
        payload.onSuccess();
      }
    }
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateOrderStatusFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateOrderStatusFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleUploadReport({ payload }) {
  try {
    // upload file
    const res = yield call(API.getFileUrl, {
      //fileName: payload.file.name,
      //source: payload.source,
      //fileUsedFor: payload.fileUsedFor,
      //companyId: payload.companyId,
      //orderId: payload.orderId,

      blobName: payload.file.name,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const url = res.data?.data?.document;
    const formData = new FormData();
    formData.append("file", payload.file);
    const fileUploadRes = yield call(API.uploadFile, { data: formData, url });
    if (fileUploadRes.status > 400) {
      throw new Error("Error uploading file");
    }
    // update order
    const fileUploadedUrl = new URL(url);
    const pathName = fileUploadedUrl?.pathname.slice(1);
    const updatePayload = {
      data: {
        reportFile: pathName,
        // status: payload.status,
      },
      id: payload.id,
    };
    if (payload.status) {
      updatePayload.data.status = payload.status;
    }
    const updateRes = yield call(API.updateOrder, updatePayload);
    yield put(actions.uploadReportSuccess(updateRes.data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.uploadReportFailure({ id: payload.id, err }));
    payload.onFailure();
  }
}

export function* handleUpdateSampleReceived({ payload }) {
  try {
    // update sample received
    console.log(payload.data.labSampleReceivedDetails);
    yield call(
      API.saveLabSampleResponseDetails,
      payload.data.labSampleReceivedDetails
    );
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.updateSampleReceivedFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleMoveToUnderTesting({ payload }) {
  try {
    // if (payload.data.labSampleReceivedDetails) {
    //   console.log(payload.data.labSampleReceivedDetails);
    //   yield call(API.updateOrderStatus, payload.data.labSampleReceivedDetails);
    // }
    // delete payload.data.labSampleReceivedDetails;

    const res = yield call(API.updateOrderStatus, payload);
    yield put(actions.moveToUnderTestingSuccess(res.data));
    payload?.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateOrderStatusFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateOrderStatusFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* orderDetailsSaga() {
  yield takeLatest(actions.fetchOrderDetails.type, handleFetchOrders);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeEvery(actions.updateOrderStatus.type, handleUpdateOrderStatus);
  yield takeEvery(actions.uploadReport.type, handleUploadReport);
  yield takeEvery(
    actions.updateSampleReceived.type,
    handleUpdateSampleReceived
  );
  yield takeEvery(actions.downloadFile.type, handleDownloadReport);
  yield takeEvery(actions.moveToUnderTesting.type, handleMoveToUnderTesting);
}
